import React from "react";
import { Tag } from "antd";
import { ColumnsType } from "antd/lib/table";

import designSystemColors from "../../styles";
import { TServiceProtocols } from "./types";

const parseDateForSorting = (dateString: string) => {
  if (!dateString) return new Date(0);

  const [datePart, timePart] = dateString.split(", ");
  const [day, month, year] = datePart.split("/");

  const standardDateString = `${year}/${month}/${day} ${timePart}`;

  return new Date(standardDateString);
};

export const columns: ColumnsType<TServiceProtocols> = [
  {
    title: "Nº Protocolo",
    dataIndex: "numeroProtocolo",
    key: "numeroProtocolo",
    align: "center",
    sorter: (a, b) => a.numeroProtocolo.localeCompare(b.numeroProtocolo),
  },
  {
    title: "ID do Portador",
    dataIndex: "idPortador",
    key: "idPortador",
    align: "center",
    sorter: (a, b) => +a.idPortador - +b.idPortador,
  },
  {
    title: "Nome Portador",
    dataIndex: "nomePortador",
    key: "nomePortador",
    align: "center",
    sorter: (a, b) => a.nomePortador.localeCompare(b.nomePortador),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    sorter: (a, b) => a.status.localeCompare(b.status),
    render: (status) => {
      const color =
        status === "FINALIZADO"
          ? designSystemColors.activateGreen
          : designSystemColors.warningColor;
      return (
        <Tag
          color={color}
          style={{
            borderRadius: "4px",
            fontWeight: "bold",
            width: "80px",
            height: "25px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {status.toUpperCase()}
        </Tag>
      );
    },
  },
  {
    title: "Data/Hora de Criação",
    dataIndex: "dataCriacao",
    key: "dataCriacao",
    align: "center",
    sorter: (a, b) =>
      parseDateForSorting(a.dataCriacao as string).getTime() -
      parseDateForSorting(b.dataCriacao as string).getTime(),
  },
  {
    title: "Criado Por",
    dataIndex: "criadoPor",
    key: "criadoPor",
    align: "center",
    sorter: (a, b) => a.criadoPor.localeCompare(b.criadoPor),
  },
  {
    title: "Data/Hora de Finalização",
    dataIndex: "dataFinalizacao",
    key: "dataFinalizacao",
    align: "center",
    sorter: (a, b) =>
      parseDateForSorting(a.dataFinalizacao as string).getTime() -
      parseDateForSorting(b.dataFinalizacao as string).getTime(),
  },
  {
    title: "Finalizado Por",
    dataIndex: "finalizadoPor",
    key: "finalizadoPor",
    align: "center",
    sorter: (a, b) =>
      (a.finalizadoPor || "").localeCompare(b.finalizadoPor || ""),
  },
];
